<template>
    <div
        :class="{
            'pz-help-center-guider': true,
            'pz-help-center-guider--hidden': !linkList
        }"
    >
        <div class="pz-help-center-guider__title">
            {{ this.$t('guider.title') }}
        </div>
        <div class="pz-help-center-guider__content">
            <a
                v-for="(item, index) in linkList"
                :key="index"
                class="pz-help-center-guider__link-item"
                target="_blank"
                :href="item.href"
            >
                {{ item.label }}
            </a>
        </div>
        <div
            v-if="linkMore"
            class="pz-help-center-guider__footer"
        >
            <a
                class="pz-help-center-guider__more"
                :href="linkMore.href"
                target="_blank"
            >{{ linkMore.label }}</a>
            <PtIcon
                class="pz-help-center-guider__more-icon"
                icon="SolidArrowTailRight"
            />
        </div>
    </div>
</template>
<script>
/* eslint-disable max-len */
import PtIcon from '@patsnap-biz/icon';
import helpCenterGuiderMixin from './mixins/help_center_guider';
import cn from '../locales/help-center-guider/cn';
import en from '../locales/help-center-guider/en';
import jp from '../locales/help-center-guider/jp';
import tw from '../locales/help-center-guider/tw';

export default {
    name: 'HelpCenterGuider',
    i18n: {
        fallbackLocale: 'cn',
        messages: {
            cn, en, jp, tw,
        },
    },
    components: {
        PtIcon,
    },
    mixins: [helpCenterGuiderMixin],
    props: {
        guiderConfig: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        linkList() {
            return this.guiderData.linkList;
        },
        linkMore() {
            return this.guiderData.linkMore;
        },
    },
};
</script>
